import React, { Fragment } from 'react'
import Link from 'gatsby-link'
import styled from 'react-emotion';

const PageTitle = styled.h2`
  font-size: 22px;
  font-family: 'Sonsie One', cursive;
`

const PageBody = styled.div`
  padding: 20px;
  flex-grow: 1;
`

const Breadcrumb = styled.div`
  font-size: .8rem;
  margin-bottom: .25rem;

  & a {
    text-decoration: none;
    color: #000;
    &::after {
      content: "\00BB";
      font-size: 1rem;
      margin-left: 5px;
    }
  }
`
const PageLinks = styled.ul`
  display:flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: "flex-start";
  margin-left: 0;
  padding: 20px;
  list-style-type: none;
  margin-bottom: 0;
  
  & li {
    margin-bottom: 0;
    display: inline-block;
  }

  & span {
    padding: 10px;
  }
  & a {
    text-decoration: none;
    color: #222;
    background-color: #e3cf34;
    padding: 10px;
    border-radius: 10px;
    display:block;
    & i {
      font-size: .7em;
    }
  }
`

const PageComponent = (props) => {
  const { nextPage, prevPage, page } = props.data;

  return (
    <Fragment>
      <PageBody>
        <Breadcrumb><Link to={`/${props.data.page.chapter.slug}/`}>{props.data.page.chapter.title}</Link></Breadcrumb>
        <PageTitle>{page ? page.title : null}</PageTitle>
        <div dangerouslySetInnerHTML={{ __html: props.data.page.body.childMarkdownRemark.html }} />
      </PageBody>
      <PageLinks>
        <li>
        {prevPage != null ?
          <Link to={`/${page.chapter.slug}/${prevPage.path}/`}><i className="icon-277" /> {prevPage.title}</Link>
        : <span>&nbsp;</span> }
        </li>
        <li>
        {nextPage != null ?
          <Link to={`/${page.chapter.slug}/${nextPage.path}/`}>{nextPage.title} <i className="icon-276" /></Link>
        : "" }
        </li>
      </PageLinks>
    </Fragment>
  )
}

export default PageComponent

export const pageQuery = graphql`
query PageQuery($id: String!, $nextPage: String, $prevPage: String) {
  page: contentfulPage(id:{ eq: $id }) {
    title
    body {
      childMarkdownRemark {
        html
      }
    }
    pageNumber
    chapter {
      slug
      title
    }
  }
  nextPage: contentfulPage(id: { eq: $nextPage }) {
    title
    path
  }
  prevPage: contentfulPage(id: { eq: $prevPage }) {
    title
    path
  }
}
`


// WEBPACK FOOTER //
// ./src/components/page.js